<script setup lang="ts">
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const emit = defineEmits(['click'])
</script>

<template>
	<button
		class="bs-go-back flex cursor-pointer items-center gap-4px border-none bg-transparent p-0 focus:outline-none focus-visible:outline-none"
		@click="$emit('click')"
	>
		<div class="bs-go-back__icon-wrapper">
			<BaseIcon
				name="arrow_left_new"
				class="bs-icon flex h-24px w-24px items-center justify-center fill-n-950"
			></BaseIcon>
		</div>
		<span class="typography-s1-reg text-n-950">
			<slot>GoBack</slot>
		</span>
	</button>
</template>
